<phdsoft-sideboard
  class="automatic-point-wizard-sideboard"
  [options]="optionsWindow"
  (ok)="submit()"
  (cancel)="closeWindow()"
>
  <div content class="advanced-launcher" *ngIf="isButtonOpen">
    <button (click)="toggleShow()" mat-raised-button>
      <mat-icon>miscellaneous_services</mat-icon>
      Advanced
    </button>
  </div>

  <div content *ngIf="isShown" class="point-wizard-content">
    <div class="point-wizard-pages">
      <!-- General -->
      <div [hidden]="pageIndex !== 0" overlayColor="transparent" class="page-container">
        <div class="wizard-step-identity" aria-live="polite">
          <div class="wizard-step-current">
            <span class="wizard-step-marker" aria-hidden="true"></span>
            <mat-label class="wizard-step-name">General Settings</mat-label>
            <span class="wizard-step-position">Step 1 of 6</span>
          </div>
        </div>

        <div class="slide-navigation-buttons">
          <button
            id="basic"
            class="wizard-navigation-button wizard-navigation-button--next"
            type="button"
            mat-button
            (click)="next()"
          >
            Next
            <mat-icon aria-hidden="true">chevron_right</mat-icon>
          </button>
        </div>

        <div class="slide-body general-settings-step">
          <div class="region-selection-container">
            <phdsoft-region-selection
              [inputRegions]="_AutomaticPoints.GeneralSettings.Regions"
              (selectedElementIds)="onSelectedElementIds($event)"
              (selectedRegionsData)="onSelectedRegionsData($event)"
            >
            </phdsoft-region-selection>
          </div>
        </div>
      </div>

      <!-- Presets -->
      <div *ngIf="pageIndex == 1" overlayColor="transparent" class="page-container">
        <div class="wizard-step-identity" aria-live="polite">
          <div class="wizard-step-current">
            <span class="wizard-step-marker" aria-hidden="true"></span>
            <mat-label class="wizard-step-name">Presets</mat-label>
            <span class="wizard-step-position">Step 2 of 6</span>
          </div>
        </div>

        <div class="slide-navigation-buttons">
          <button id="basic" class="wizard-navigation-button" type="button" mat-button (click)="back()">
            <mat-icon aria-hidden="true">chevron_left</mat-icon>
            Back
          </button>

          <button
            id="basic"
            class="wizard-navigation-button wizard-navigation-button--next"
            type="button"
            mat-button
            (click)="next()"
          >
            Next
            <mat-icon aria-hidden="true">chevron_right</mat-icon>
          </button>
        </div>

        <div class="slide-body presets-step">
          <!-- Presets Header -->
          <div class="presets-header">
            <mat-label class="section-heading">Available presets</mat-label>
            <button
              class="compact-icon-button compact-icon-button--positive"
              mat-icon-button
              matTooltip="New Preset"
              (click)="openCreatePresetDialog()"
            >
              <mat-icon>add</mat-icon>
            </button>
          </div>

          <!-- Inline create preset input -->
          <div *ngIf="showCreatePresetDialog" class="preset-inline-editor">
            <input [(ngModel)]="newPresetName" placeholder="Preset name" class="preset-name-input">
            <button
              class="compact-icon-button compact-icon-button--positive"
              mat-icon-button
              (click)="saveAsNewPreset()"
              [disabled]="!newPresetName.trim() || isSavingPreset"
              matTooltip="Save"
            >
              <mat-icon>check</mat-icon>
            </button>
            <button
              class="compact-icon-button"
              mat-icon-button
              (click)="cancelCreatePreset()"
              matTooltip="Cancel"
            >
              <mat-icon>close</mat-icon>
            </button>
          </div>

          <!-- Loading indicator -->
          <div *ngIf="isLoadingPresets" class="presets-loading-state">
            <mat-spinner diameter="30"></mat-spinner>
            <p>Loading presets...</p>
          </div>

          <!-- Presets List -->
          <div *ngIf="!isLoadingPresets" class="presets-list">
            <div
              *ngFor="let preset of presets"
              class="preset-item"
              [class.preset-item--selected]="selectedPreset?.id === preset.id"
              [ngStyle]="{
                'border-color': selectedPreset?.id === preset.id ? '#7f7f7f' : '#5a5a5a',
                'background-color': preset.isHovered && selectedPreset?.id !== preset.id ? '#7f7f7f' : (selectedPreset?.id === preset.id ? '#4d4f4c' : 'transparent')
              }"
              (mouseenter)="preset.isHovered = true"
              (mouseleave)="preset.isHovered = false"
              (click)="selectPreset(preset)"
            >
              <!-- Normal view -->
              <div
                *ngIf="presetToRename?.id !== preset.id && presetToDelete?.id !== preset.id"
                class="preset-summary"
              >
                <mat-radio-button
                  class="preset-radio"
                  color="primary"
                  [checked]="selectedPreset?.id === preset.id"
                  (click)="$event.stopPropagation()"
                  (change)="selectPreset(preset)"
                >
                </mat-radio-button>
                <div class="preset-details">
                  <span *ngIf="!preset.isDefault" class="preset-name">{{ preset.name }}</span>
                  <span *ngIf="preset.isDefault" class="preset-default-label">Default</span>
                  <span *ngIf="!preset.isDefault && preset.createdBy" class="preset-author">{{ preset.createdBy }}</span>
                </div>
              </div>

              <!-- Inline rename input -->
              <div
                *ngIf="presetToRename?.id === preset.id"
                class="preset-inline-editor preset-inline-editor--row"
                (click)="$event.stopPropagation()"
              >
                <input [(ngModel)]="newPresetName" placeholder="Preset name" class="preset-name-input">
                <button
                  class="compact-icon-button compact-icon-button--positive"
                  mat-icon-button
                  (click)="renamePreset()"
                  [disabled]="!newPresetName.trim() || isSavingPreset"
                  matTooltip="Save"
                >
                  <mat-icon>check</mat-icon>
                </button>
                <button
                  class="compact-icon-button"
                  mat-icon-button
                  (click)="cancelRenamePreset()"
                  matTooltip="Cancel"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </div>

              <!-- Inline delete confirmation -->
              <div
                *ngIf="presetToDelete?.id === preset.id"
                class="preset-delete-confirmation"
                (click)="$event.stopPropagation()"
              >
                <span>Delete?</span>
                <button
                  class="compact-icon-button compact-icon-button--danger"
                  mat-icon-button
                  (click)="confirmDeletePreset()"
                  [disabled]="isSavingPreset"
                  matTooltip="Confirm Delete"
                >
                  <mat-icon>check</mat-icon>
                </button>
                <button
                  class="compact-icon-button"
                  mat-icon-button
                  (click)="cancelDeletePreset()"
                  matTooltip="Cancel"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </div>

              <!-- Actions -->
              <div
                *ngIf="!preset.isDefault && presetToRename?.id !== preset.id && presetToDelete?.id !== preset.id"
                class="tw-flex tw-shrink-0 preset-card-actions"
                [class.tw-opacity-100]="selectedPreset?.id === preset.id"
                [class.tw-opacity-0]="selectedPreset?.id !== preset.id"
                [class.tw-pointer-events-none]="selectedPreset?.id !== preset.id"
                [class.hover:tw-opacity-100]="selectedPreset?.id !== preset.id"
                [class.tw-transition-opacity]="selectedPreset?.id !== preset.id"
              >
                <button
                  class="compact-icon-button"
                  mat-icon-button
                  matTooltip="Rename"
                  (click)="openRenamePresetDialog(preset); $event.stopPropagation()"
                >
                  <mat-icon>edit</mat-icon>
                </button>
                <button
                  class="compact-icon-button compact-icon-button--danger"
                  mat-icon-button
                  matTooltip="Delete"
                  (click)="openDeletePresetDialog(preset); $event.stopPropagation()"
                  [disabled]="isSavingPreset"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Plates -->
      <div *ngIf="pageIndex == 2" overlayColor="transparent" class="page-container">
        <div class="wizard-step-identity" aria-live="polite">
          <div class="wizard-step-current">
            <span class="wizard-step-marker" aria-hidden="true"></span>
            <mat-label class="wizard-step-name">Plates Settings</mat-label>
            <span class="wizard-step-position">Step 3 of 6</span>
          </div>
        </div>

        <div class="slide-navigation-buttons">
          <button id="basic" class="wizard-navigation-button" type="button" mat-button (click)="back()">
            <mat-icon aria-hidden="true">chevron_left</mat-icon>
            Back
          </button>

          <button
            id="basic"
            class="wizard-navigation-button wizard-navigation-button--next"
            type="button"
            mat-button
            (click)="next()"
          >
            Next
            <mat-icon aria-hidden="true">chevron_right</mat-icon>
          </button>
        </div>

        <div class="slide-body settings-step">
          <div content class="wizard-section wizard-section--first">
            <form [formGroup]="form" #signUpForm="ngForm" class="normal-form settings-form">
              <table class="settings-table toggle-settings-table">
                <tr>
                  <td>
                    <mat-checkbox
                      class="settings-checkbox"
                      value="3"
                      [(ngModel)]="_AutomaticPoints.PlatesSettings.PositionGaugingsforPlates"
                      [ngModelOptions]="{standalone: true}"
                      id="al3"
                      binary="true"
                    >
                      Position gauging points on plates
                    </mat-checkbox>
                    <mat-checkbox
                      class="settings-checkbox"
                      value="3"
                      [(ngModel)]="_AutomaticPoints.PlatesSettings.PositionGaugingsforCriticalAreas"
                      [ngModelOptions]="{standalone: true}"
                      id="criticalArea"
                      binary="true"
                    >
                      Position gauging points on critical areas
                    </mat-checkbox>
                    <div class="inline-number-field">
                      <label
                        *ngIf="_AutomaticPoints.PlatesSettings.PositionGaugingsforCriticalAreas"
                        for="criticalAreaThreshold"
                      >
                        Critical area threshold
                      </label>
                      <input
                        type="number"
                        *ngIf="_AutomaticPoints.PlatesSettings.PositionGaugingsforCriticalAreas"
                        name="criticalAreaThreshold"
                        min="0"
                        max="100"
                        step="1"
                        size="4"
                        [(ngModel)]="_AutomaticPoints.PlatesSettings.CriticalAreaThreshold"
                        [ngModelOptions]="{standalone: true}"
                      >
                    </div>

                    <mat-checkbox
                      class="settings-checkbox"
                      value="3"
                      [(ngModel)]="_AutomaticPoints.PlatesSettings.PositionGaugingsforAnomalies"
                      [ngModelOptions]="{standalone: true}"
                      id="anomalies"
                      binary="true"
                    >
                      Position gauging points on anomalies
                    </mat-checkbox>
                    <div class="inline-number-field">
                      <label
                        *ngIf="_AutomaticPoints.PlatesSettings.PositionGaugingsforAnomalies"
                        for="criticalAreaThreshold"
                      >
                        Anomalies threshold
                      </label>
                      <input
                        type="number"
                        *ngIf="_AutomaticPoints.PlatesSettings.PositionGaugingsforAnomalies"
                        name="criticalAreaThreshold"
                        min="0"
                        max="100"
                        step="1"
                        size="4"
                        [(ngModel)]="_AutomaticPoints.PlatesSettings.AnomaliesThreshold"
                        [ngModelOptions]="{standalone: true}"
                      >
                    </div>
                  </td>
                </tr>
              </table>
            </form>
          </div>

          <div content *ngIf="_AutomaticPoints.PlatesSettings.PositionGaugingsforPlates" class="wizard-section">
            <div class="slide-body-content">
              <label for="nome" class="section-heading">Positioning Criteria</label>
              <table class="settings-table criteria-table criteria-table--plates">
                <thead>
                  <tr class="box-modal-header">
                    <th>Range</th>
                    <th>Area</th>
                    <th>Size</th>
                    <th>Number Of points</th>
                    <th>
                      <span *ngIf="!isOnLinesSelected">Add Center Point</span>
                      <span *ngIf="isOnLinesSelected">Number of rows</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let PlatesPointCriteria of _AutomaticPoints.PlatesSettings.PositionPointCriteriaList">
                    <td class="readonly-value">over</td>
                    <td>
                      <input
                        type="number"
                        min="0.09"
                        max="200"
                        name="area_plates"
                        step="0.5"
                        [(ngModel)]="PlatesPointCriteria.Area"
                        size="4"
                      >
                    </td>
                    <td class="readonly-value measurement-unit">m²</td>
                    <td>
                      <input
                        type="number"
                        min="1"
                        max="10"
                        name="nrpoints_plates"
                        [(ngModel)]="PlatesPointCriteria.NumberOfPoints"
                        size="4"
                      >
                    </td>
                    <td>
                      <input
                        *ngIf="!isOnLinesSelected"
                        class="native-checkbox"
                        type="checkbox"
                        [(ngModel)]="PlatesPointCriteria.AddCenterPoint"
                        [ngModelOptions]="{standalone: true}"
                        id="al31"
                        binary="true"
                      >
                      <input
                        *ngIf="isOnLinesSelected"
                        type="number"
                        min="1"
                        max="10"
                        name="nrpoints_onrow_plates"
                        [(ngModel)]="PlatesPointCriteria.NumberOfRows"
                        size="4"
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Maximum Distance Section -->
          <div content *ngIf="_AutomaticPoints.PlatesSettings.PositionGaugingsforPlates" class="wizard-section">
            <div class="slide-body-content">
              <div class="section-heading">Minimum Distances</div>
              <table class="settings-table distance-table">
                <tr>
                  <td>Minimum distance between points:</td>
                  <td>
                    <input
                      type="number"
                      min="0.09"
                      max="200"
                      name="minDistanceBetweenPoints"
                      step="0.01"
                      [(ngModel)]="_AutomaticPoints.PlatesSettings.MinimumDistanceBetweenPoints"
                      size="4"
                    >
                  </td>
                  <td class="readonly-value measurement-unit">m</td>
                </tr>
                <tr>
                  <td>Minimum distance from edges:</td>
                  <td>
                    <input
                      type="number"
                      min="0.01"
                      max="200"
                      name="minDistanceFromEdges"
                      step="0.01"
                      [(ngModel)]="_AutomaticPoints.PlatesSettings.MinimumDistanceFromEdges"
                      size="4"
                    >
                  </td>
                  <td class="readonly-value measurement-unit">m</td>
                </tr>
                <tr>
                  <td>Minimum distance from elements:</td>
                  <td>
                    <input
                      type="number"
                      min="0.01"
                      max="200"
                      name="minDistanceFromElements"
                      step="0.01"
                      [(ngModel)]="_AutomaticPoints.PlatesSettings.MinimumDistanceFromElements"
                      size="4"
                    >
                  </td>
                  <td class="readonly-value measurement-unit">m</td>
                </tr>
              </table>
            </div>
          </div>

          <!-- Points Arrangement Radio Buttons -->
          <div content *ngIf="_AutomaticPoints.PlatesSettings.PositionGaugingsforPlates" class="wizard-section">
            <div class="slide-body-content">
              <label for="nome" class="section-heading">Points Arrangement</label>
              <mat-radio-group
                class="arrangement-group"
                [(ngModel)]="_AutomaticPoints.PlatesSettings.PointsArrangements"
                (change)="onPlatesArrangementChange($event.value)"
                [ngModelOptions]="{standalone: true}"
              >
                <table class="arrangement-grid">
                  <tr>
                    <td>
                      <mat-radio-button class="arrangement-option" color="primary" [value]="PointsArrangements.AscendingDiagonal">
                        <img src="./statics/plates/Plate1.jpg">
                      </mat-radio-button>
                    </td>
                    <td>
                      <mat-radio-button class="arrangement-option" color="primary" [value]="PointsArrangements.DescendingDiagonal">
                        <img src="./statics/plates/Plate2.jpg">
                      </mat-radio-button>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <mat-radio-button class="arrangement-option" color="primary" [value]="PointsArrangements.Linear">
                        <img src="./statics/plates/Plate3.jpg">
                      </mat-radio-button>
                    </td>
                    <td>
                      <mat-radio-button class="arrangement-option" color="primary" [value]="PointsArrangements.ZigZag">
                        <img src="./statics/plates/Plate4.jpg">
                      </mat-radio-button>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <mat-radio-button class="arrangement-option" color="primary" [value]="PointsArrangements.OnLines">
                        <img src="./statics/plates/Plate7.jpg">
                      </mat-radio-button>
                    </td>
                    <td>
                      <mat-radio-button class="arrangement-option" color="primary" [value]="PointsArrangements.Pattern">
                        <img src="./statics/plates/Plate6.jpg">
                      </mat-radio-button>
                    </td>
                  </tr>
                </table>
              </mat-radio-group>
            </div>
          </div>
        </div>
      </div>

      <!-- Stiffeners -->
      <div *ngIf="pageIndex == 3" overlayColor="transparent" class="page-container">
        <div class="wizard-step-identity" aria-live="polite">
          <div class="wizard-step-current">
            <span class="wizard-step-marker" aria-hidden="true"></span>
            <mat-label class="wizard-step-name">Stiffeners Settings</mat-label>
            <span class="wizard-step-position">Step 4 of 6</span>
          </div>
        </div>

        <div class="slide-navigation-buttons">
          <button id="basic" class="wizard-navigation-button" type="button" mat-button (click)="back()">
            <mat-icon aria-hidden="true">chevron_left</mat-icon>
            Back
          </button>
          <button
            id="basic"
            class="wizard-navigation-button wizard-navigation-button--next"
            type="button"
            mat-button
            (click)="next()"
          >
            Next
            <mat-icon aria-hidden="true">chevron_right</mat-icon>
          </button>
        </div>

        <div class="slide-body settings-step">
          <div content class="wizard-section wizard-section--first">
            <div class="slide-body-content">
              <table class="settings-table stiffener-toggle-table">
                <tr class="stiffener-option-row">
                  <td colspan="2">
                    <mat-checkbox
                      class="settings-checkbox"
                      value="1"
                      [(ngModel)]="_AutomaticPoints.StiffenersSettings.PositionGaugingPointsOnStiffeners"
                      [ngModelOptions]="{standalone: true}"
                      id="gaugingStiffeners"
                      binary="true"
                    >
                      Position gauging points on stiffeners
                    </mat-checkbox>
                  </td>
                </tr>
                <tr class="stiffener-option-row stiffener-spacing-row">
                  <td>
                    <mat-checkbox
                      class="settings-checkbox"
                      value="1"
                      [(ngModel)]="_AutomaticPoints.StiffenersSettings.PositionGaugingPointsOnFrames"
                      [ngModelOptions]="{standalone: true}"
                      id="pointsOnFrames"
                      binary="true"
                    >
                      Position points on longitudinals with spacing
                    </mat-checkbox>
                  </td>
                  <td>
                    <input
                      type="number"
                      *ngIf="_AutomaticPoints.StiffenersSettings.PositionGaugingPointsOnFrames"
                      name="FrameSpacing"
                      min="0.9"
                      max="100"
                      step="0.5"
                      [(ngModel)]="_AutomaticPoints.StiffenersSettings.FrameSpacing"
                      size="4"
                    >
                  </td>
                </tr>
              </table>
            </div>
          </div>

          <div
            content
            *ngIf="_AutomaticPoints.StiffenersSettings.PositionGaugingPointsOnStiffeners || _AutomaticPoints.StiffenersSettings.PositionGaugingPointsOnBays"
            class="wizard-section"
          >
            <div class="slide-body-content">
              <label for="nome" class="section-heading">Positioning Criteria</label>
              <table class="settings-table criteria-table criteria-table--length">
                <thead>
                  <tr class="box-modal-header">
                    <th>Range</th>
                    <th>Length</th>
                    <th>Size</th>
                    <th>Number Of points</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let InspectionAppliedStiffeners of this._AutomaticPoints.StiffenersSettings.PositionPointCriteriaList">
                    <td class="readonly-value">over</td>
                    <td>
                      <input
                        type="number"
                        name="Length"
                        min="0.9"
                        max="100"
                        step="0.5"
                        [(ngModel)]="InspectionAppliedStiffeners.Length"
                        size="4"
                      >
                    </td>
                    <td class="readonly-value measurement-unit">m</td>
                    <td>
                      <input
                        type="number"
                        name="NrPoints"
                        min="1"
                        max="10"
                        [(ngModel)]="InspectionAppliedStiffeners.NumberOfPoints"
                        size="4"
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div
            content
            *ngIf="_AutomaticPoints.StiffenersSettings.PositionGaugingPointsOnStiffeners || _AutomaticPoints.StiffenersSettings.PositionGaugingPointsOnBays"
            class="wizard-section"
          >
            <div class="slide-body-content">
              <label for="nome" class="section-heading">Stiffener's Part</label>
              <form [formGroup]="form" #signUpForm="ngForm" class="normal-form settings-form">
                <table class="settings-table toggle-settings-table">
                  <tr>
                    <td>
                      <mat-checkbox
                        class="settings-checkbox"
                        [(ngModel)]="_AutomaticPoints.StiffenersSettings.InsertPointsOnWeb"
                        [ngModelOptions]="{standalone: true}"
                        value="1"
                        binary="true"
                      >
                        Insert points on web
                      </mat-checkbox>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <mat-checkbox
                        class="settings-checkbox"
                        [(ngModel)]="_AutomaticPoints.StiffenersSettings.InsertPointsOnFlange"
                        [ngModelOptions]="{standalone: true}"
                        value="1"
                        binary="true"
                      >
                        Insert points on flange
                      </mat-checkbox>
                    </td>
                  </tr>
                </table>
              </form>
            </div>
          </div>
        </div>
      </div>

      <!-- Faceplates -->
      <div *ngIf="pageIndex == 4" overlayColor="transparent" class="page-container">
        <div class="wizard-step-identity" aria-live="polite">
          <div class="wizard-step-current">
            <span class="wizard-step-marker" aria-hidden="true"></span>
            <mat-label class="wizard-step-name">Face Plates Settings</mat-label>
            <span class="wizard-step-position">Step 5 of 6</span>
          </div>
        </div>

        <div class="slide-navigation-buttons">
          <button id="basic" class="wizard-navigation-button" type="button" mat-button (click)="back()">
            <mat-icon aria-hidden="true">chevron_left</mat-icon>
            Back
          </button>

          <button
            id="basic"
            class="wizard-navigation-button wizard-navigation-button--next"
            type="button"
            mat-button
            (click)="next()"
          >
            Next
            <mat-icon aria-hidden="true">chevron_right</mat-icon>
          </button>
        </div>

        <div class="slide-body settings-step">
          <div content class="wizard-section wizard-section--first">
            <div class="slide-body-content">
              <table class="settings-table toggle-settings-table">
                <tr>
                  <td>
                    <mat-checkbox
                      class="settings-checkbox"
                      [(ngModel)]="_AutomaticPoints.FacePlatesSettings.PositionGaugingPointsOnFacePlates"
                      [ngModelOptions]="{standalone: true}"
                      id="al5"
                      binary="true"
                    >
                      Position gauging points on face plates
                    </mat-checkbox>
                  </td>
                </tr>
              </table>
            </div>
          </div>

          <div
            content
            *ngIf="_AutomaticPoints.FacePlatesSettings.PositionGaugingPointsOnFacePlates"
            class="wizard-section"
          >
            <div class="slide-body-content">
              <label for="nome" class="section-heading">Positioning Criteria</label>
              <table class="settings-table criteria-table criteria-table--length">
                <thead>
                  <tr class="box-modal-header">
                    <th>Range</th>
                    <th>Length</th>
                    <th>Size</th>
                    <th>Number Of points</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let InspectionAppliedFacePlates of this._AutomaticPoints.FacePlatesSettings.PositionPointCriteriaList">
                    <td class="readonly-value">over</td>
                    <td>
                      <input
                        type="number"
                        name="Length"
                        min="0.01"
                        max="100"
                        step="0.5"
                        [(ngModel)]="InspectionAppliedFacePlates.Length"
                        size="4"
                      >
                    </td>
                    <td class="readonly-value measurement-unit">m</td>
                    <td>
                      <input
                        type="number"
                        name="NrPoints"
                        min="1"
                        max="10"
                        [(ngModel)]="InspectionAppliedFacePlates.NumberOfPoints"
                        size="4"
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- Brackets -->
      <div *ngIf="pageIndex == 5" overlayColor="transparent" class="page-container">
        <div class="wizard-step-identity" aria-live="polite">
          <div class="wizard-step-current">
            <span class="wizard-step-marker" aria-hidden="true"></span>
            <mat-label class="wizard-step-name">Brackets Settings</mat-label>
            <span class="wizard-step-position">Step 6 of 6</span>
          </div>
        </div>

        <div class="slide-navigation-buttons">
          <button id="basic" class="wizard-navigation-button" type="button" mat-button (click)="back()">
            <mat-icon aria-hidden="true">chevron_left</mat-icon>
            Back
          </button>
        </div>

        <div class="slide-body settings-step">
          <div content class="wizard-section wizard-section--first">
            <div class="slide-body-content">
              <table class="settings-table toggle-settings-table">
                <tr>
                  <td>
                    <mat-checkbox
                      class="settings-checkbox"
                      value="1"
                      [(ngModel)]="_AutomaticPoints.BracketSettings.PositionGaugingPointsOnBrackets"
                      [ngModelOptions]="{standalone: true}"
                      id="al7"
                      binary="true"
                    >
                      Position gauging points on face brackets
                    </mat-checkbox>
                  </td>
                </tr>
              </table>
            </div>
          </div>

          <div
            content
            *ngIf="_AutomaticPoints.BracketSettings.PositionGaugingPointsOnBrackets"
            class="wizard-section"
          >
            <div class="slide-body-content">
              <label for="nome" class="section-heading">Positioning Criteria</label>
              <table class="settings-table criteria-table criteria-table--brackets">
                <thead>
                  <tr class="box-modal-header">
                    <th>Area</th>
                    <th>Size</th>
                    <th>Web Points</th>
                    <th>Range Points</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let _PositionPointCriteriaBrackets of _AutomaticPoints.BracketSettings.PositionPointCriteriaList">
                    <td>
                      <input
                        type="number"
                        min="0.5"
                        max="100"
                        step="0.5"
                        [(ngModel)]="_PositionPointCriteriaBrackets.Area"
                        size="4"
                      >
                    </td>
                    <td class="readonly-value measurement-unit">m²</td>
                    <td>
                      <input
                        type="number"
                        min="1"
                        max="10"
                        name="ticketNum"
                        [(ngModel)]="_PositionPointCriteriaBrackets.NumberOfPointsWeb"
                        size="4"
                      >
                    </td>
                    <td>
                      <input
                        type="number"
                        min="1"
                        max="10"
                        [(ngModel)]="_PositionPointCriteriaBrackets.NumberOfPointsFlange"
                        size="4"
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Checkbox Points Composition -->
          <div
            content
            *ngIf="_AutomaticPoints.BracketSettings.PositionGaugingPointsOnBrackets"
            class="wizard-section"
          >
            <div class="slide-body-content">
              <label for="nome" class="section-heading">Points Arrangement</label>
              <form [formGroup]="form" #signUpForm="ngForm" class="normal-form settings-form">
                <mat-radio-group
                  class="arrangement-group"
                  [(ngModel)]="_AutomaticPoints.BracketSettings.PointsArrangement"
                  [ngModelOptions]="{standalone: true}"
                >
                  <table class="arrangement-grid">
                    <tr>
                      <td>
                        <mat-radio-button class="arrangement-option" color="primary" [value]="PointsArrangements.DescendingDiagonal">
                          <img src="./statics/bracket/Bracket1.jpg">
                        </mat-radio-button>
                      </td>
                      <td>
                        <mat-radio-button class="arrangement-option" color="primary" [value]="PointsArrangements.OnVertices">
                          <img src="./statics/bracket/Bracket2.jpg">
                        </mat-radio-button>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <mat-radio-button class="arrangement-option" color="primary" [value]="PointsArrangements.OnEdges">
                          <img src="./statics/bracket/Bracket3.jpg">
                        </mat-radio-button>
                      </td>
                    </tr>
                  </table>
                </mat-radio-group>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Custom footer buttons for preset actions -->
  <div footer class="preset-footer-actions">
    <button
      class="preset-footer-button"
      mat-icon-button
      matTooltip="Save Preset"
      (click)="updateCurrentPreset()"
      [disabled]="!selectedPreset || selectedPreset.isDefault || isSavingPreset"
    >
      <mat-icon>save</mat-icon>
    </button>
  </div>
</phdsoft-sideboard>
